import React, { useMemo, useState } from "react";
import { api } from "../api";

function normalizeRc(value) {
    return (value || "").replaceAll(" ", "").replaceAll("/", "").trim();
}
function normalizeName(value) {
    return (value || "").trim().replace(/\s+/g, " ").toUpperCase();
}

function ResultBox({ ok, registered }) {
    const tone = ok ? (registered ? "border-ok/35 bg-ok/10" : "border-bad/35 bg-bad/10") : "border-bad/35 bg-bad/10";
    return (
        <div className={["rounded-2xl border p-5", tone].join(" ")}>
            <div className="text-text-100 font-semibold text-lg">
                {ok ? (registered ? "Registrováno" : "Není registrováno") : "Chyba"}
            </div>
        </div>
    );
}

export default function Verify() {
    const [name, setName] = useState("");
    const [rc, setRc] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [registered, setRegistered] = useState(null);

    const payload = useMemo(() => {
        return { name: normalizeName(name), rc: normalizeRc(rc) };
    }, [name, rc]);

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setRegistered(null);

        if (!payload.name || !payload.rc) {
            setErr("missing_fields");
            return;
        }

        setBusy(true);
        try {
            const res = await api.verify(payload.name, payload.rc);
            setRegistered(!!res.registered);
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "verify_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="card overflow-hidden">
            <div className="cardHeader">
                <div className="text-text-100 font-extrabold text-2xl">Ověření dokladu</div>
                <div className="text-text-300 mt-2">Vrací pouze ano nebo ne</div>
            </div>

            <div className="cardBody">
                <form onSubmit={onSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                        <div>
                            <div className="label">Jméno a příjmení</div>
                            <input value={name} onChange={(e) => setName(e.target.value)} className="input mt-3" placeholder="JAN NOVÁK" autoComplete="off" />
                        </div>

                        <div>
                            <div className="label">Rodné číslo</div>
                            <input value={rc} onChange={(e) => setRc(e.target.value)} className="input mt-3" placeholder="990101/1234" inputMode="numeric" autoComplete="off" />
                        </div>
                    </div>

                    {err ? (
                        <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                            <div className="text-text-100 font-semibold">Nelze ověřit</div>
                            <div className="text-text-200 text-sm mt-1">{err}</div>
                        </div>
                    ) : null}

                    <div className="flex flex-col sm:flex-row gap-3">
                        <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed" : "btnPrimary"}>
                            {busy ? "Ověřuji" : "Ověřit"}
                        </button>

                        <button
                            type="button"
                            className="btnGhost"
                            onClick={() => {
                                setName("");
                                setRc("");
                                setErr("");
                                setRegistered(null);
                            }}
                        >
                            Vyčistit
                        </button>
                    </div>

                    {registered !== null && !err ? <ResultBox ok registered={registered} /> : null}
                </form>
            </div>
        </section>
    );
}
